


export class ToTheTop {
    offset = 100
    constructor(element) {
        this.button = element;
        this.button.addEventListener('click', () => {
            this.scrollUp();
        });
        window.addEventListener('scroll', () => {
            this.showHide();
        });
        this.showHide();
    }
    showHide() {
        if(window.scrollY > this.offset) {
            this.button.classList.add('active');
        }
        else {
            this.button.classList.remove('active');
        }
    }
    scrollUp() {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    }
}

